import { Injectable } from '@angular/core';
import { Subject ,  Observable } from 'rxjs';

@Injectable()
export class AuthInterceptorService {
  public get unauthorized(): Observable<void> { return this.unauthorizedSubject; }
  public  unauthorizedSubject: Subject<void> = new Subject<void>();
}
